import axios from "axios";
import store from "../config/store/store";
import { axiosError } from "../Stores/action/action";
import { logoutUser } from "../../components/auth/service/service";
import { LAD_APISERVER_URL } from "configs/base.config";

export const api = axios.create({
  baseURL: LAD_APISERVER_URL,
});

api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if(!axios.isCancel(error)) {
      if (
        !error.response.config.url.endsWith("/thumbnail") &&
        !error.response.config.url.endsWith("/unlock") &&
        !error.response.config.url.endsWith("/image?bin") &&
        !error.response.config.url.endsWith("/thumbnail?bin") &&
        !(
          error.response.config.url.startsWith("/builder/drawings/") &&
          error.response.config.url.endsWith("/file?bin")
        ) &&
        error.response.config.url.search(/\/site-photos\/.+\/info/) === -1 &&
        !error.response.config.url.includes("/logwalk-viewer/shoots")
      ) {
        switch (error.response.status) {
          case 404:
            if (
              (error.response.config.url.endsWith("/exists") &&
                error.response.config.method === "post") ||
              (error.response.config.url.endsWith("/infos") &&
                error.response.config.method === "post") ||
              // NOTE: 権限の取得は画面表示の付随処理。失敗しても画面全体を
              //       エラーにしない（API 未リリース時などに全画面が
              //       ErrorPage になってしまうため）。
              (error.response.config.url.endsWith("/lb-users/me") &&
                error.response.config.method === "get")
            ) {
              break;
            }
            store.dispatch(axiosError(error.response));
            break;
          case 401:
            store.dispatch(axiosError(error.response));
            store.dispatch(logoutUser());
            break;
          default:
            break;
        }
      }
    }
    return Promise.reject(error);
  }
);
